import React from 'react'
import { string } from 'prop-types'

import ContentWrapper from 'components/atoms/ContentWrapper'
import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import SectionTitle from 'components/atoms/SectionTitle'

const SchoolTuition = ({ tuitionInfo }) => (
  <div className="school-tuition" id="tuition">
    <div className="school-tuition__gray-accent"/>
    {/* <div className="school-tuition__blue-bg-accent"/> */}
    <SectionContainer
      className="school-tuition__content"
      backgroundColor="transparent"
      paddingTop={120}
    >
      <Container>
        <SectionTitle title="Biaya Kuliah" />
        <ContentWrapper content={tuitionInfo} />
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .school-tuition {
          position: relative;
          background: #fff;
          overflow: hidden;
          :global(h3, h4) {
            color: #0c2846;
            font-size: 16px;
            @media screen and (min-width: 768px) {
              font-size: 20px;
            }
          }
          :global(h3) {
            font-weight: bold;
          }
          :global(h4) {
            font-weight: 600;
          }
          &__blue-bg-accent {
            position: absolute;
            background-color: #1c80e7;
            bottom: 0;
            left: 0;
            right: 0;
            height: 30%;
            transform: skewY(-8deg);
            transform-origin: bottom right;
          }
          &__gray-accent {
            background: #f6f7fa;
            position: absolute;
            top: 20%;
            left: 0;
            right: 0;
            height: 40%;
            transform: skewY(-8deg);
          }
          :global(&__content) {
            position: relative;
          }
        }
      `}
    </style>
  </div>
)

SchoolTuition.propTypes = {
  tuitionInfo: string,
}

export default SchoolTuition
